import React from "react";
import styled from "styled-components";

const RadioGroup = ({ value, onChange, options, disabled }) => {
  const handleRadioChange = (value) => {
    if (disabled) return;
    onChange && onChange(value);
  };

  return (
    <RadioContainer>
      {options.map((option) => (
        <Radio
          key={option.value}
          checked={value === option.value}
          onClick={() => handleRadioChange(option.value)}
          disabled={disabled}
        >
          <RadioButton
            disabled={disabled}
            isChecked={value === option?.value}
          />
          <OptionLabel disabled={disabled}>{option.label}</OptionLabel>
        </Radio>
      ))}
    </RadioContainer>
  );
};

export default RadioGroup;

export const RadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const Radio = styled.div`
  display: flex;
  gap: 8px;
  padding: 16px 12px;
  cursor: pointer;
  width: 100%;
  border: 1px solid ${({ disabled }) => (disabled ? "#E8E8E8" : "black")};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  border-radius: 8px;
`;

export const RadioButton = styled.div`
  min-width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid ${({ disabled }) => (disabled ? "#A6A6A6" : "black")};
  position: relative;

  &:after {
    content: "";
    width: 10px;
    height: 10px;
    background-color: ${({ disabled }) => (disabled ? "#A6A6A6" : "black")};
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: ${(props) => (props.isChecked ? "block" : "none")};
  }
`;

export const OptionLabel = styled.div`
  font-size: 16px !important;
  line-height: 20px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ disabled }) => (disabled ? "#A6A6A6" : "black")};
`;
